import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { TagInputModule } from 'ngx-chips';
import { FourDotFivePhoneNumberModule } from 'src/app/shared/four-dot-five-phone-number/four-dot-five-phone-number.module';
import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { AddEditUserPageComponent } from './add-edit-user-page.component';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.usermanagement',
    url: '/user',
    component: AddEditUserPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      accessMode: null,
      userId: null,
      manager: null,
      purpose: null
    }
  }
];

@NgModule({
  declarations: [AddEditUserPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    TagInputModule,
    FourDotFivePhoneNumberModule,
    InfoIconModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [AddEditUserPageComponent],
  entryComponents: [AddEditUserPageComponent]
})
export class AddEditUserPageModule { }
